import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class PaAutopilotScheduleOption extends Model {
  [Type] = 'pa-autopilot-schedule-option' as const;

  @attr declare times: string[];
}
